import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import SearchSectionNode from '@Pages/QueryBuilder/SearchSection/SearchSectionNode/SearchSectionNode';

function FormsTab({ nodes, getForms, addToBuilder }) {
  useEffect(() => {
    if (isEmpty(nodes)) {
      getForms();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="query-builder-search-section__forms-tab">
      {nodes.length > 0 &&
        nodes.map((node, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <SearchSectionNode node={node} level={0} index={index} key={`level-0-index-${index}`} addToBuilder={addToBuilder} />
        ))}
    </div>
  );
}

FormsTab.propTypes = {
  nodes: PropTypes.array.isRequired,
  getForms: PropTypes.func.isRequired,
  addToBuilder: PropTypes.func.isRequired,
};

export default FormsTab;
